export default {
  personneMorale: {
    creation: {
      title: 'Création de personne morale',
    },
    detail: {
      title: {
        default: 'Personne morale',
        new: 'Nouvelle personne morale',
        sub: 'Informations sur la personne morale',
      },
      form: {
        nomUsuel: 'Nom usuel',
        raisonSociale: 'Raison sociale',
        id: 'ID',
        sirenOuSiret: 'SIREN/SIRET',
        sirenOuSiretTooltip:
          'SIREN/SIRET de l\'entreprise ou numéro RNA de l\'association. Indiquez 0 pour une entreprise étrangère',
        type: 'Type',
        mail: 'Adresse mail',
        fax: 'Fax',
        contextes: 'Contextes',
        maisonsMeres: {
          title: 'Filiale de (0)|Filiale de (1)|Filiale de ({count})',
          add: 'Ajouter une maison-mère',
          remove: 'Supprimer une maison-mère',
          dialog: {
            description:
              'Sélectionner une personne morale en tant que maison-mère',
          },
        },
        filiales: {
          title: 'Filiale (0)|Filiale (1)|Filiales ({count})',
        },
        cotiseA: 'Cotise à',
        domicilieeMDL: 'Domiciliée MDL',
        organisationPro: 'Organisation professionnelle',
        siteInternet: 'Site Internet',
        panel: {
          divisions: {
            title: 'Division (0)|Division (1)|Divisions ({count})',
            search: 'Filtrer par nom',
            dialog: {
              title: 'Divisions et contacts',
              typeSelection: 'Inclure les subdivisions',
              search: 'Filtrer',
            },
          },
          membres: {
            title: 'Membre (0)|Membre (1)|Membres ({count})',
          },
        },
      },
    },
  },
};
